module.exports = __webpack_public_path__ + "img/shapepurple.06610b3e.png";